<template>
  <div class="columns">
    <div class="column is-narrow">
      <router-link
        v-if="redirect"
        :to="redirect"
        class="tw-flex tw-items-center tw-text-base tw-self-center has-text-primary"
      >
        <b-icon icon="chevron-left" size="is-medium"></b-icon>
        <span class="tw-font-semibold">BACK</span>
      </router-link>
      <a
        class="tw-flex tw-items-center tw-text-base tw-self-center has-text-primary"
        v-else
      >
        <b-icon icon="chevron-left" size="is-medium"></b-icon>
        <span class="tw-font-semibold" @click.prevent="goBackByHistory()"
          >BACK</span
        >
      </a>
    </div>
    <div class="column"></div>
  </div>
</template>

<script>
export default {
  props: {
    redirect: {
      type: Object
    }
  },
  methods: {
    goBackByHistory() {
      if (!this.redirect) {
        this.$router.back()
      }
    }
  }
}
</script>
